import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export const SubmitEnvelopeErrorDialog = (props) => {

    const {submitEnvelopeError, setSubmitEnvelopeError} = props

    useEffect(() => {
        let timeoutId;
        if (submitEnvelopeError) {
            timeoutId = setTimeout(() => {
                setSubmitEnvelopeError(false)
            }, 2000);
        }
        return () => {
            clearTimeout(timeoutId)

        };
    }, [submitEnvelopeError, setSubmitEnvelopeError]);

    return (
        <dialog
            className="dialog--temporary"
            open={submitEnvelopeError}
            onClose={()=>setSubmitEnvelopeError(false)}
        >
            <div className="dialog__row-container">
                <header>
                    <h2>
                    Erro ao enviar o envelope
                    </h2>
                </header>
                <IconButton 
                    onClick={()=>setSubmitEnvelopeError(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </dialog>
    );
}